import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Modal,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import { Postrequestcall } from "../../../../request/Postrequest";
import { useSelector } from "react-redux";
import { FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW } from "../../../../constant/Apipath";
import Getcurrentlocation from "../../../../common/Getcurrentlocation";
import TimesheetSkeletonLoader from "../components/TimesheetSkeletonLoader";

import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import { BIGrey } from "../../../../assets/helpers";

let CLIENT_COLOR = "#000000";

const SelectJob = ({
  isOpen,
  onClose,
  setInputValue,
  selectedValue,
  setSelectedValue,
  setSelectActivities,
  setFromjob,
  setActivityList
}) => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);

  const TOKEN = loginData?.accessToken;
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const CLIENT_ID = selectedClientData?.ClientId;

  const { TEXT_SORT_BY, TEXT_NEAR_BY, TEXT_RECENT, TEXT_SELECT_JOB, TEXT_NO_JOBS_FOUND } =
    ClientEnglishFallback?.SelectJobModal(multiLanguageData?.SelectJobModal || {});

  const [clientJobList, setClientJobList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sortByNearby, setSortByNearby] = useState(false);

  useEffect(() => {
    if (isOpen === true) {
      getClientJobs();
    }
  }, [isOpen, sortByNearby]);

  const getClientJobs = async () => {
    try {
      setLoader(true);
      let getValue = await Getcurrentlocation();
      const payload = {
        PageNumber: 1,
        NrRowsPerPage: 100,
        UserLatitude: getValue?.lat,
        UserLongitude: getValue?.lng,
        ClientId: CLIENT_ID,
        SortBy: sortByNearby ? 1 : 2,
        ClientEmployeeId: selectedClientData?.ClientEmployeeId
      };
      const response = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT_NEW, payload, TOKEN);
      if (response.status === 200) {
        let getUpdated = response?.data?.data?.map((item) => {
          return {
            ...item,
            checked: selectedValue?.clientJobCodeId === item?.clientJobId
          };
        });
        setClientJobList(getUpdated ?? []);
      }
    } catch (error) {
      console.error("getClientJobs-> Error ", error);
    } finally {
      setLoader(false);
    }
  };

  const onSelectjob = (e, item) => {
    e.preventDefault();
    if (selectedValue?.clientJobCodeId !== item?.clientJobId) {
      if (typeof setActivityList === "function") {
        setActivityList([]);
      }
    }
    setSelectedValue({
      clientEmployeeId: selectedClientData?.ClientEmployeeId,
      clientJobCodeId: item?.clientJobId,
      clientJobUDFieldsList: item?.clientJobUDFieldsList || [],
      clientJobActivitiesList: item?.clientJobActivitiesList || []
    });
    setFromjob(true);
    setSelectActivities(true);
    onClose();
    setInputValue(`${item.clientJobCode} - ${item.clientJobName} `);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          padding: {
            xs: "10px",
            xl: "15px",
            lg: "15px",
            md: "15px",
            sm: "10px"
          },
          minHeight: "500px"
        }}
        className="client-modal-responsive">
        {loader ? (
          <Box sx={{ width: "100%" }}>
            <TimesheetSkeletonLoader variant="selectJob" />
          </Box>
        ) : (
          <>
            <Stack sx={{ display: "flex", mb: 1, justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
              <IconButton onClick={onClose} style={{ padding: "4px" }}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
              <Typography variant="h6">{TEXT_SELECT_JOB}</Typography>
              <Stack
                sx={{ cursor: "pointer", gap: 0.5, alignItems: "center" }}
                onClick={() => setSortByNearby((prev) => !prev)}
                direction={"row"}>
                <Typography>{TEXT_SORT_BY}</Typography>
                <Typography sx={{ color: CLIENT_COLOR }}>
                  {sortByNearby ? TEXT_NEAR_BY : TEXT_RECENT}{" "}
                </Typography>
              </Stack>
            </Stack>
            {clientJobList?.length === 0 ? (
              <Stack sx={{ justifyContent: "center", alignItems: "center", height: "100px", width: "100%", minHeight: "400px" }}>
                <Typography sx={{ color: BIGrey }}>{TEXT_NO_JOBS_FOUND}</Typography>
              </Stack>
            ) : (
              <List sx={{ overflowY: "auto", maxHeight: "500px", scrollbarWidth: "none" }}>
                {clientJobList?.map((item) => {
                  const hasActivities = item?.clientJobActivitiesList?.length > 0;
                  return (
                    <ListItem
                      className="pagelist-content"
                      onClick={(e) => {
                        if (hasActivities) onSelectjob(e, item);
                      }}
                      sx={{
                        cursor: hasActivities ? "pointer" : "not-allowed",
                        border: item?.checked
                          ? `1px solid ${CLIENT_COLOR}`
                          : "1px solid rgb(216 216 216)",
                        marginBottom: "10px",
                        borderRadius: "10px",
                        opacity: hasActivities ? 1 : 0.6,
                        backgroundColor: hasActivities ? "transparent" : "#f5f5f5",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}>
                      <ListItemText primary={item?.clientJobCode + "-" + item?.clientJobName} />
                      {!hasActivities && (
                        <Tooltip title="No activity associate with this job" placement="top" arrow onClick={(e) => e.stopPropagation()}>
                          <IconButton size="small">
                            <InfoIcon color="disabled" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </ListItem>
                  );
                })}
              </List>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default SelectJob;
